import { STRINGS } from '@/strings/strings';

/**
 * Series credit soft-gate hint. When the user has enough credits for every
 * episode, shows the full "N Folgen · 1 Credit je Folge · du hast X Credits."
 * line; when short, shows the deferred-episodes line. Pure + testable.
 */
export function seriesCreditHint(episodeCount: number, credits: number): string {
  const S = STRINGS.series.builder;
  const missing = episodeCount - credits;
  if (missing > 0) {
    return S.creditHintShort
      .replace('{credits}', String(credits))
      .replace('{missing}', String(missing));
  }
  return S.creditHint
    .replace('{count}', String(episodeCount))
    .replace('{credits}', String(credits));
}
